import { render, staticRenderFns } from "./order-details-container.vue?vue&type=template&id=6d40f094&scoped=true&lang=pug"
import script from "./order-details-container.js?vue&type=script&lang=js&external"
export * from "./order-details-container.js?vue&type=script&lang=js&external"
import style0 from "./order-details-container.vue?vue&type=style&index=0&id=6d40f094&prod&lang=scss"
import style1 from "./order-details-container.vue?vue&type=style&index=1&id=6d40f094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40f094",
  null
  
)

export default component.exports